export default __webpack_public_path__ + "static/media/webinar2.3ca48baf.jpeg";